import { render } from "./presenters.vue?vue&type=template&id=4fee8c19&scoped=true"
import script from "./presenters.vue?vue&type=script&lang=js"
export * from "./presenters.vue?vue&type=script&lang=js"

import "./presenters.vue?vue&type=style&index=0&id=4fee8c19&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4fee8c19"

export default script